<template>
  <div id="app" class="ui-container">
      <div class="background-grad"></div>
      <div class="background"></div>
      <div class="ui">

          <header>
                <h1> Loge La Force no. 230 </h1>
                <h2> Res Non Verba </h2>
          </header>

          <div class="hamburger" v-on:click="showMenu">
              <div class="dashes">
                  <div class="dash">&nbsp;</div>
                  <div class="dash">&nbsp;</div>
                  <div class="dash">&nbsp;</div>
              </div>
          </div>

          <transition name="fade" mode="out-in">
              <nav v-if="menushown">
                  <ul>
                      <router-link to="/"><li> Welkom </li></router-link>
                      <router-link to="/vrijmetselarij"><li> Vrijmetselarij </li></router-link>
                      <router-link to="/over-onze-loge"><li> Over onze loge </li></router-link>
                      <router-link to="/artikelen"><li> Artikelen </li></router-link>
                      <router-link to="/werktafel"><li> Werktafel </li></router-link>
                      <router-link to="/informatie"><li> Meer informatie </li></router-link>
                  </ul>
              </nav>
          </transition>

          <transition name="fade" mode="out-in">
              <router-view></router-view>
          </transition>

          <footer>
              <h3> Loge La Force no. 230 </h3>
              <h4> Amsterdamseweg 168-170 1182 HK Amstelveen <span><a href="mailto:logelaforce@gmail.com">logelaforce@gmail.com</a></span> </h4>
          </footer>

      </div>
  </div>
</template>

<script>

export default {
  name: 'app',
  data: () => {
      return {
          menushown: (window.screen.width >= 667) ? true : false,
      }
  },
  methods: {
      showMenu() {
          this.menushown = !this.menushown
      }
  },
  watch: {
      $route () {
          this.menushown = (window.screen.width >= 667) ? true : false
      }
  },
  mounted () {
      this.menushown = (window.screen.width >= 667) ? true : false
      window.addEventListener('resize', () => {
          this.menushown = (window.screen.width >= 667) ? true : false
      })
  }
}
</script>

<style>

    @import url('https://fonts.googleapis.com/css?family=Nunito+Sans&display=swap');

    /* -------------------------------- */

    html {
        scroll-behavior: smooth;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    html, body {
        margin: 0;
        padding: 0;
        background: #171e28;
        min-height: 100%;
        height: 100%;
        width: 100%;
    }

    body {
        box-sizing: border-box;
        padding-bottom: 180px;
    }

    .background {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
        background: #171e28 url('/images/broederketen.png') no-repeat center center;
        /* # 000026 */
        background-size: cover;
    }

    .background-grad {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-image: linear-gradient(rgba(0,0,0,0), rgba(0,0,26,1));
    }

    /* -------------------------------- */

    header {
        /* margin-bottom: 20px; */
        box-sizing: border-box;
        /* padding-bottom: 20px; */
        padding: 20px 0 20px 15px;
        /* background: rgba(0, 1, 20, .13); */
        /* background: #000016; */
    }

    nav {
        position: sticky;
        top: 0px;
        box-sizing: border-box;
        /* border-bottom: solid 5px #002427; */
        /* background: black; */
        /* box-shadow: 0 0 20px black, 0 0 50px black; */
        /* background-image: linear-gradient(rgba(0, 1, 20, .7) 90%, rgba(0, 1, 20, .1)); */
        /* background: rgba(0, 1, 20, .3); */
        padding: 0 3px 13px 10px;
        z-index: 30;
        border-radius: 5px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        transition: background .21s linear;
        background: #000000;
    }

    /* nav:hover  {
        background: #000000dd;
    } */

    hr {
        border: none;
        border-bottom: solid 1px rgba(1, 0, 48, .7);
        margin: 40px 0;
    }

    hr.special {
        border-bottom: solid 1px orange;
    }

    .content {
        box-sizing: border-box;
        padding: 0 10px 180px 10px;
    }

    footer {
        position: sticky;
        bottom: 0px;
        /* background: black; */
        background: #000016;
        width: 970px;
        min-width: 970px;
        max-width: 970px;
        box-sizing: border-box;
        padding: 20px 30px;
        border: solid 1px #002427;
        border-bottom: none;
        box-shadow: 0 -10px 40px #00000045;
        z-index: 23;
    }

    .image-logo-footer {
        position: absolute;
        width: 80px;
        height: 80px;
        left: 0;
        top: 0;
        background: transparent url('/images/logo.png') no-repeat center center;
        background-size: contain;
    }

    /* -------------------------------- */

    /* -------------------------------- */

    h1, h2, h3, h4, h5, h6, span, p, a, pre, button, li, td {
        color: white;
        /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
        font-family: 'Nunito Sans', sans-serif;
    }

    td {
        vertical-align: text-top;
        min-width: 300px;
        font-size: 19px;
        line-height: 32px;
    }

    td ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    .button {
        border: none;
        background: #ddd;
        color: black;
        font-size: 18px;
        box-sizing: border-box;
        padding: 10px 20px;
        border-radius: 5px;
        cursor: pointer;
        display: inline-block;
        margin-top: 10px;
    }

    .button:hover {
        background: white;
        box-shadow: 0 0 10px white;
    }

    .button:active {
        transform: translateY(1px);
    }

    .button:focus {
        outline: none;
    }

    h1, h2, h3, h4 {
        margin: 0;
    }

    h1 {
        font-size: 26px;
        color: #6f7486;
        margin-top: 20px;
    }

    h2 {
        font-size: 14px;
        color: #414a67;
    }

    h4 {
        /* max-width: 100%; */
    }

    h5 {
        font-size: 14px;
        font-weight: bold;
        text-transform: uppercase;
        margin: 0;
        padding: 0;
        margin-top: 40px;
    }

    h6 {
        font-size: 17px;
        margin: 0;
    }

    p {
        font-size: 19px;
        line-height: 32px;
    }

    p.quote {
        color: #31ff7c;
        font-size: 24px;
        text-align: center;
        display: block;
        font-style: italic;
        margin: 60px 0;
        box-sizing: border-box;
        padding: 60px 20%;
        /* border: solid 1px #002427; */
        border: solid 1px rgba(1, 0, 48, .7);
        border-left: none;
        border-right: none;
    }

    p.quote span.author {
        color: white;
    }

    .concern {
        /* color: #31ff7c; */
        color: blueviolet;
    }

    .question {
        color: orange;
    }

    .answer {
        color: gray;
    }

    pre {
        font-size: 12px;
        font-style: italic;
        /* color: #555; */
        color: #2f3354;
        /* word-break: break-all; */
    }

    /* -------------------------------- */

    nav ul {
        margin: 0;
        padding: 0;
        list-style-type: none;
        margin: 5px 10px 0 0;
    }

    nav li {
        display: inline-block;
        box-sizing: border-box;
        padding: 8px 6px;
        color: #5f667b;
        margin-bottom: -5px;
    }

    nav a.router-link-exact-active li {
        /* border-bottom: solid 5px #00A0B0; */
        color: white;
        font-weight: bold;
    }

    /* nav a.router-link-active li {
        border-bottom: solid 5px #00A0B0;
    } */

    nav li:hover {
        color: #00A0B0;
        background-color: #151a27;
    }

    a {
        color: pink;
        text-decoration: none;
    }

    .image  {
        /* opacity: .7; */
        /* transition: opacity .6s ease-out; */
        box-shadow: inset 0px 0px 10px #ffa50039;
    }

    .image-no-glow {
        box-shadow: none;
    }

    /* .image:hover {
        opacity: 1;
    } */

    p {
        /* opacity: .7; */
        /* transition: opacity .3s ease-out; */
    }

    /* p:hover {
        opacity: 1;
    } */

    p a {
        color: #00A0B0;
        text-decoration: underline;
        opacity: .8;
    }

    /* -------------------------------- */

    .image {
        width: 100%;
        min-height: 100px;
        border-radius: 3px;
    }

    /* -------------------------------- */

    .ui-container {
        display: flex;
        justify-content: center;
    }

    .ui {
        display: flex;
        flex-direction: column;
        min-width: 970px;
        max-width: 970px;
        width: 970px;
        z-index: 1;
        /* box-shadow: 0 0 10px #fff; */
    }

    p::selection {
        color: black;
        background-color: white;
    }

    /* -------------------------------- */

    .fade-enter-active, .fade-leave-active {
        transition-duration: 0.2s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0;
    }

    /* -------------------------------- */

    .f-c {
        display: flex;
        margin-bottom: 40px;
    }
    .f-1 {
        flex: 1;
        margin-right: 30px;
    }
    .f-1:last-child {
        margin-right: 0;
    }

    /* -------------------------------- */

    .proceedings a li {
        font-size: 17px;
        color: cyan;
    }

    .em {
        font-style: italic;
    }

    .hamburger {
        display: none;
        position: fixed;
        top: 15px;
        right: 15px;
        width: 45px;
        height: 45px;
        border: solid 1px #444;
        border-radius: 30px;
        background: black;
        box-shadow: 0 0 30px black;
        z-index: 39;
    }

    .dashes {
        position: absolute;
        left: 13px;
        top: 16px;
        /* background: yellow; */
        width: 100px;
        height: 100px;
        display: block;
    }

    .dash {
        position: absolute;
        /* left: 30px; */
        height: 2px;
        width: 19px;
        background: white;
        display: block;
        border-radius: 5px;

    }

    .dash:nth-child(1) {
        /* top: 40px; */
        top: 0;
    }

    .dash:nth-child(2) {
        top: 6px;
    }

    .dash:nth-child(3) {
        top: 12px;
    }

    /* -------------------------------- */

    /* iPhone 6, 7, & 8 in portrait */

    @media only screen and (min-device-width : 320px) and (max-device-width : 667px) and (orientation : portrait) {
        header {
            padding: 12px 20px;
            z-index: 33;
        }
        nav ul {
            margin: 0;
        }
        h3, h4 {
            font-size: 10px;
        }
        nav {
            position: fixed;
            top: 0;
            z-index: 40;
            width: 100%;
            /* height: 100%; */
            /* background: rgba(0, 1, 20, .6); */
            box-sizing: border-box;
            background: #000000;
        }
        nav ul a li {
            font-size: 22px;
            display: block;
            padding: 30px;
        }
        footer {
            max-width: 100%;
            min-width: 100%;
            width: 100%;
        }
        .content {
            padding: 20px;
        }
        .f-c {
            flex-direction: column;
        }
        .f-1 {
            margin-right: 0;
        }
        p {
            /* line-height: 150%; */
        }
        pre {
            white-space: pre-wrap;
            white-space: -moz-pre-wrap;
            white-space: -pre-wrap;
            white-space: -o-pre-wrap;
            word-wrap: break-word;
        }
        .hamburger {
            display: block;
        }
        .ui {
            max-width: 100%;
            min-width: 100%;
            width: 100%;
        }
        .image {
            width: 100%;
            box-sizing: border-box;
            padding: 20px;
        }
        hr {
            margin: 40px 0 50px 0;
            /* border-bottom: solid 1px #00A0B0; */
            border-bottom: solid 1px #000048;
        }
        .image-eye {
            background: transparent url('/images/eye-dollar.jpg') no-repeat center center !important;
            height: 100px !important;
            margin-top: 10px !important;
        }
        .image-broeders, .image-brothers, .image-compass, .image-loge, .image-tools, .image-poortwachter, .image-boosheid, .image-vrijheid, .image-openheid, .image-zoektocht, .image-parels, .image-rituelen, .image-vriendschap, .image-naald, .image-molen, .image-broederschap, .image-moderne-vrijmetselarij, .image-inwijding, .image-symboliek, .image-werktafel {
            background-position: center center !important;
        }
        .wt-row {
            border: none !important;
        }
        .wt-event {
            width: 100% !important;
            max-width: 100% !important;
            min-width: 100% !important;
            border: none !important;
            margin-bottom: 2px;
        }
        #upcoming {
            display: inline-block !important;
        }
        img, p {
            opacity: 1;
        }
    }

    /* @media only screen and (min-device-width : 320px) and (max-device-width : 568px) and (orientation : portrait) {

    } */

</style>
